import React from 'react'
import { ProvideAuth } from './Auth/use-auth'

import Login from './Auth/Login'
import SignUp from './Auth/SignUp'
import { createMuiTheme } from '@material-ui/core/styles'
import { ThemeProvider } from '@material-ui/styles'
import { HashRouter, Switch, Route, Redirect } from 'react-router-dom'
import SearchContext from './SearchContext'
import MainBoard from './MainBoard'
import NotFoundPage from './NotFoundPage'
import UpdateJob from './UpdateJob'
import GroupsCRUD from './GroupsCRUD'
import ClientCRUD from './ClientCRUD '
import InsertGroup from './InsertGroup'
import InsertClient from './InsertClient'
import InsertCar from './insertCar'
import ViewCar from './ViewCar'
//import PrintQ from './PrintQ'
import PrintQD from './PrintQD'
import PrintOut from './PrintOut'

// https://material.io/resources/color/#!/?view.left=0&view.right=0&primary.color=2196F3&secondary.color=B0BEC5
const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#6ec6ff',
      main: '#2196f3',
      dark: '#0069c0',
      contrastText: '#000000'
    },
    secondary: {
      light: '#e2f1f8',
      main: '#b0bec5',
      dark: '#808e95',
      contrastText: '#000000'
    }
  }
})

function App (props) {
  const [globalFilter, SetGlobalFilter] = React.useState('')
  const [selectedDate, setSelectedDate] = React.useState(new Date() + '')

  //<Route exact path='/' component={Login} />
  //component={user && MainBoard && Login} />
  return (
    <ProvideAuth>
      <SearchContext.Provider
        value={{
          globalFilter,
          SetGlobalFilter,
          selectedDate,
          setSelectedDate
        }}
      >
        <ThemeProvider theme={theme}>
          <HashRouter>
            <Switch>
              <Route exact path='/' component={Login} />
              <Route exact path='/signup' component={SignUp} />
              <Route path='/mb' component={MainBoard} />
              <Route path='/update/:jobId' component={UpdateJob} />
              <Route path='/insert/:choice' component={InsertGroup} />
              <Route
                path='/insertClient/:choice/:clientId'
                component={InsertClient}
              />
              <Route path='/insertCar/:field/:id' component={InsertCar} />
              <Route path='/viewCar/:carId/:clientName' component={ViewCar} />
              <Route path='/groupsCRUD' component={GroupsCRUD} />
              <Route path='/clientCRUD' component={ClientCRUD} />
              <Route path='/printquery' component={PrintQD} />
              <Route path='/printout/:algus/:lopp/' component={PrintOut} />
              <Route component={NotFoundPage} />
            </Switch>
          </HashRouter>
        </ThemeProvider>
      </SearchContext.Provider>
    </ProvideAuth>
  )
}

export default App
// <Route path='/signup' component={SignUp} />
//{ user } && <Redirect from='/' to='/mb' />
//</ProvideAuth></MongoContext.Provider>
// Stitch.defaultAppClient.auth.addAuthListener(auth => {
//   this.setState({ isAuth: auth.isLoggedIn });
// })
